module.exports = __webpack_public_path__ + "img/Screenshot_7.13de44b5.png";